import React from "react";
import "./styles.scss";
import { Link } from "react-router-dom";

const App = () => {
	return (
		<div className="bpl-container">
			<section className={"admin_noticeDetail"}>
				<div className="top">
					<h3 className="list_name">Notice</h3>
				</div>
				
				<div className="bottom">
					<table>
						<tbody>
						<tr>
							<td>제목</td>
							<td>
								공지 제목입니다.
							</td>
						</tr>
						<tr>
							<td>첨부파일</td>
							<td>filename.doc</td>
						</tr>
						<tr>
							<td colspan="2">내용</td>
						</tr>
						<tr>
							<td colspan="2">
								공지내용이 들어가는 위치입니다.
							</td>
						</tr>
						</tbody>
					</table>
					
					<div className="bottom">
						<div className="btn_box">
							<div className="new_btn fix">
								<Link to="/admin/write">수정</Link>
							</div>
							
							<div className="new_btn cancel">
								<Link to="/admin/notice">목록</Link>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	)
}

export default App;